
import React, { Suspense, useEffect, useState } from 'react'
import { useFeatureFlag } from "@harnessio/ff-react-client-sdk";
import userProfileStore from "../../core/UserProfileStore";
import { useTheme } from '../../theme/useTheme';
import { useOktaAuth } from "@okta/okta-react";
import { Aiva } from '../../../util/aivaRemote';
import {useApplicationStore} from '../../home/ApplicationStore';
import {useGlobalStore} from "../../core/GlobalStore";
import { useWebViewStore } from '../../webview/useWebViewStore';
import { useHistory } from 'react-router-dom';
import { Workflow } from '../../../types';
import { getAccessToken } from '../../okta/authService';

  function AivaWrapper()  
{
    const hasAivaPermission = useFeatureFlag("UNIFY_UI_AIVA");
    const { oktaAuth } = useOktaAuth();
    const { darkMode } = useTheme();
    const [accessTokenForAiva, setAccessTokenForAiva] = useState('');
    const { applications , workflows} = useApplicationStore();
    const iamUserProfile = userProfileStore(state => state.iamUserProfile);
    const [ expandAiva, setExpandAiva ] = useState(false);    
    const { permissions } = userProfileStore();
    const {isAivaOpen,setAivaOpen,setAivaMinimized} = useGlobalStore() ;
    const { getActiveIframe , webviews } = useWebViewStore();
    const activeFrame = getActiveIframe();
    const history = useHistory();
    const [ userLocation, setUserLocation ] = useState(({}) as any);
    const [ showOnTop, setShowOnTop ] = useState(false);
    const { setAivaAccess } = userProfileStore();


    useEffect(() => {
        const fetchToken = async () => {
            const token = await getAccessToken();
            if (token) setAccessTokenForAiva(token);
        };
        fetchToken();
        const handleRenewed = (key: string, newToken: any) => {
            if (key === 'accessToken' && newToken?.accessToken) {
            setAccessTokenForAiva(newToken.accessToken);
            }
        };
        oktaAuth?.tokenManager?.on('renewed', handleRenewed);

        return () => {
            oktaAuth?.tokenManager?.off('renewed', handleRenewed);
        };
    }, [oktaAuth]);

    window.aivaAction = (action:string, value:any) => {
        window.isAivaOpened = expandAiva;
        action === 'EXPAND_AIVA' && setExpandAiva(!expandAiva);
    }

    const onAivaReady = (args:any) => {
        setAivaAccess(args?.userHasAivaAccess ?? false);
    }

    const aivaActionHandler = ({action, value}: { action: string, value: any }) => {
        history.push(`/unify/aview/${value}/N`);
    }


    useEffect(() => {
        
        if(webviews.length === 0) {
            return;
        }

        const activePane = activeFrame?.id || ''; 

        const app = applications.find((ap:any) => ap.id === activePane);
        const workflow = workflows?.find((wf: Workflow) => wf.id === activePane);
        const activeWebview = webviews.find((wv) => wv.id === activePane);
        
        let activeApp = {};
        let navUrl = "";

        if(activeWebview?.visitedOrigin && activeWebview?.visitedPath) {
            navUrl = (activeWebview?.visitedOrigin || '') + (activeWebview?.visitedPath || '');
            if(activeWebview.type === 'application'){
                activeApp = {
                    application:{
                        id: app?.id,
                        name: app?.name,
                    },
                    navURL: navUrl,
                }
            }else {
                const appName = applications.find((ap:any) => ap.id === workflow?.appId)?.name;
                activeApp = {
                application:{
                    id: workflow?.appId,
                    name: appName,
                    workflow: {
                        id: workflow?.id,
                        name: workflow?.name,
                    }
                },
                navURL: navUrl,
            }
        }
        }else if (app && app.url) {
            activeApp = {
                    application:{
                        id: app?.id,
                        name: app?.name,
                    },
                    navURL: app?.url,
                }
        }else if (workflow && workflow.url) {
            const appName = applications.find((ap:any) => ap.id === workflow?.appId)?.name;
            activeApp = {
                application:{
                    id: workflow?.appId,
                    name: appName,
                    workflow: {
                        id: workflow?.id,
                        name: workflow?.name,
                    }
                },
                navURL: workflow?.url,
            }
        }
                      
        setUserLocation(activeFrame ? activeApp : {});
        setShowOnTop(!!activePane);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getActiveIframe,webviews,applications,workflows]);

    if (!hasAivaPermission) {
        window.aivaAction = undefined;
        window.isAivaOpened = false;
        return null;
    }
    return (
        // AIVA arrives from the MFE remote - nothing to show until it lands.
        <Suspense fallback={null}>
        <Aiva
            className={showOnTop ? 'aiva-top' : 'aiva-unify'}
            source='Unify'
            user={iamUserProfile && iamUserProfile.fullUser && { ...iamUserProfile.fullUser, permissions: permissions } }
            userLanguage={ iamUserProfile?.fullUser?.user?.locale === 'en_FR' ? 'fr'  : 'en' }
            aivaVoice={true}
            isOpen={isAivaOpen}
            handleClose={()=>{setAivaOpen(false)}}
            theme={darkMode ? 'dark' : 'light'}
            token={accessTokenForAiva}
            actionListener={ aivaActionHandler }
            userApplications={applications?.map((item: any) => { return { appId: item.id, name: item.name }})}
            onMinimize={()=>{setAivaMinimized(true)}}
            onMaximize={()=>{setAivaMinimized(false)}}
            isNewUnify={true}
            isDemo={false}
            onReady={onAivaReady}
            userRequestLocation={userLocation}
        />
        </Suspense>
    )
}

export default AivaWrapper